<template>
  <div class="form-common" v-cloak>
    <form
      id="login_form"
      class="tc layout-form"
      @submit.prevent="submitForm(loginInfo)"
    >
      <h3 class="title">Sign in</h3>
        <div class="input-group-wrap">
            <div class="input-group flex-row" :class="{error: validation.hasError('loginInfo.username') || validateName}">
                <label for="name" class="prefix pc-view">{{ hostname }}/</label>
                <label v-if="hostname.length <= 12" for="name" class="prefix mobile-view">{{ hostname }}/</label>
                <input id="name" type="text" placeholder="username" class="name" v-model.trim="loginInfo.username" name="username" autocomplete="username" >
            </div>
            <p class="error-msg tl">{{ validation.firstError('loginInfo.username')|| errName}}</p> 
        </div>
        <div class="input-group-wrap">
            <div class="input-group" :class="{error: validation.hasError('loginInfo.password') || validatePsw}">
                <input class="psw w-100" :type='showPwd? "text" : "password"' placeholder="Password"  v-model.trim="loginInfo.password" name="password" autocomplete="new-password">
                <i class="iconfont" :class="showPwd?'icon-eye-fill':'icon-eye-off-fill'"  @click="handlePwdVisibility"></i>
            </div>
            <p class="error-msg tl">{{ validation.firstError('loginInfo.password') || errPsw}}</p> 
        </div>
        <button :class="['btn','submit-btn',{loading:is_loading}]" type="submit" :style="disableBtn">Sign in</button>
        <p class="remind tc forgot"><a href="javascript:void(0)" class="link" @click='handleForgotPsw'>Forgot password?</a></p>
        <p class="remind tc">Don't have an account?&nbsp;<a href="javascript:void(0)" class="link" @click='toRegister'>Create one</a></p>
    </form>
  </div>
</template>

<script>
import userService from '../service/userService';
import {validateError} from '../../common/utils/errors';
import LS from 'local-storage';
import loading from "../../common/utils/loading";
import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;
Vue.use(SimpleVueValidation);

export default {
    data() {
        return {
            loginInfo: {
                username: '',
                password: '',
            },
            validateName: false,
            validatePsw: false,
            errName: '',
            errPsw: '',
            is_loading: false,
            showPwd:false,
        }
    },

    validators: {
        'loginInfo.username': function(value) {
            return Validator.value(value).required('The username field is required.');
        },
        'loginInfo.password': function(value) {
            return Validator.value(value).required('The password field is required.');
        },
    },

    computed: {
        disableBtn() {
            if(this.loginInfo.username && this.loginInfo.password){
                return {
                    opacity: 1
                };
            }else {
                return {
                    opacity: .3
                }
            }
        },
        hostname() {
          return window.location.host.replace('www.','') || 'freelink.com';
        }
    },
    methods: {
        submitForm: function(info){
            this.$validate().then((success)=>{
                if (success) {
                    this.clearErrMsg();
                    if(this.is_loading) return;
                    this.is_loading = true;
                    loading.show();
                    userService.login(info).then((res) => {
                      LS.set('token', res.data.token)
                      this.$router.push({
                        path: "/"
                      })
                    })
                    .catch((err) => {
                        if (err instanceof validateError) {
                            const validate = err.getError();
                            if(validate.username) {
                                this.errName = validate.username;
                                this.validateName = true
                            }

                            if(validate.password) {
                                this.errPsw = validate.password;
                                this.validatePsw = true;
                            }
                        }
                    })
                    .finally(() => {
                        this.is_loading = false;
                        loading.hide();
                    })
                }
            })
        },

        //清除校验信息
        clearErrMsg: function() {
            this.validateName = false,
            this.validatePsw = false,
            this.errName = '',
            this.errPsw = ''
        },

        toRegister:function() {
            this.$router.push({
              path: "/register"
            })
        },

        /**
         * 忘记密码
         */
        handleForgotPsw:function(){
            this.$router.push({
                path:'/forget-pwd'
            })
        },

        /**
         * 控制密码显示隐藏
         */
        handlePwdVisibility:function(){
            this.showPwd = !this.showPwd;
        },

    }
}
</script>

<style></style>
